export function toggleArrayValue<T>(source: T[], value: T, keySelector: (value: T) => string): T[] {
	const valueExists = source.some(s => keySelector(s) === keySelector(value));

	if (valueExists) {
		return source.filter(v => keySelector(v) !== keySelector(value));
	}

	return [...source, value];
}
